import Button from "@mui/material/Button";
import { Field, useFormikContext } from "formik";
import React, { useEffect, useState, useMemo, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import { CircularProgress } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {
  requestOptions,
  VIPSDataServiceURL,
  MenuURL,
} from "../../Constants/GlobalConstant";
import { calculateSum } from "../../CommonFuntion/TotalQuantity";
import { calculateInputSum } from "../../CommonFuntion/TotalQuantity";
import { getMessage } from "../../CommonFuntion/messages";
import DynamicFieldRenderer from "./DynamicFieldRenderer";
import IconButton from "@mui/material/IconButton";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  openPopup,
  getVendorIdFromSession,
  getCatalougeData,
  getELCData,
  fetchParentELCHeaderData2,
  parseExcelData,
  getCatalougeDataOnF9KeyPress,
  getELCDataOnF9KeyPress,
  deleteItemAtIndex,
  addMoreRowHelper,
  deleteRowHelper,
  handleF8KeyPress,
  handleF9KeyPress,
  handleF10KeyPress,
} from "../../CommonFuntion/TableBodyFormikHelper";
export function TableBodyFormik(props) {
  const formikProps = useFormikContext();
  let { errors, initialValues, values, setFieldValue } = formikProps;
  const {
    name,
    value,
    schemaPageFields,
    Lines,
    maxNoLines,
    schemaPageId,
    schemaResult,
    itemId,
    orientation,
    childOpt,
    setChildOpt,
    onInputChange,
    setCatTabData,
    setPurchasedQty,
    totalSum,
    setTotalSum,
    prefix,
    totalInputSum,
    setTotalInputSum,
    labelReference,
    formData,
    csvData,
    csvUplaodEnabled,
    handleResetELCList,
    resetELCList,
    columnsWithAnyData,
    searchParams,
    imagePreviewRequired,
    ELLValue,
    ELLSchemaItem,
    setELCDropDown,
    ELCDropDown,
    setIsLoading,
    toggleTescoFileUploaded,
    SetcatalogueChildOptn,
    catalogueChildOptn,
    user_id,
    store_grp,
    handleELLValue,
    handleELLVSchemaItem,
  } = props;

  // Detect if table has any QTY fields
  const hasQtyFields = useMemo(
    () => Array.isArray(schemaPageFields) && schemaPageFields.some(f => f.prefix === "QTY"),
    [schemaPageFields]
  );

  const [table, settable] = React.useState([]);
  const [catDropDown, setCatDropDown] = useState();
  const [showInputQuantity, setShowInputQuantity] = useState(true);
  const [showWastageOption, setShowWastageOption] = useState(true);
  const [loadingStates, setLoadingStates] = useState({});
  const [deleting, setDeleting] = useState(false);
  const [parentELCValue, setParentELCValue] = useState("");
  const [childOptions, setChildOptions] = useState([]);

  const [data, setData] = useState([["", "", ""]]); // Initial empty table data
  const [notification, setNotification] = useState(""); // State for the notification
  const expectedColumns = 3; // Define the number of columns you expect
  const inFlightRequestKeyRef = useRef(new Set()); // Track in-flight requests to prevent duplicates
  const handleSetOptionsForChild = (data) => {
    setChildOptions(data);
  };
  const [totalCopiedRows, setTotalCopiedRows] = useState(0);
  const [pendingPaste, setPendingPaste] = useState(null);
  const [pasteError, setPasteError] = useState(null);
  useEffect(() => {
    let arr = [];
    var numberOfLinesToDisplay = csvUplaodEnabled
      ? formData?.[name]?.length
      : formData?.[name]?.length > 0
      ? formData?.[name]?.length
      : Lines;

    for (let index = 0; index < numberOfLinesToDisplay; index++) {
      //if (Lines >= index + 1)
      arr.push(schemaPageFields);
    }
    setTotalCopiedRows(formData?.[name]?.length === Lines ? 0 : formData?.[name]?.length || 0);
    settable(arr);
    if (formData?.[name]) {
      // Only compute totals if QTY fields exist
      if (hasQtyFields) {
        setTotalSum(calculateSum(props, formData?.[name]));
        setTotalInputSum(calculateInputSum(props, formData[name]));
      }
    }
  }, [Lines, schemaPageFields, formData, hasQtyFields]);

  useEffect(() => {
    // Inform global validation whether this table has qty fields
    window.__tableHasQty = hasQtyFields;
  }, [hasQtyFields]);

  useEffect(() => {
    // Inform global validation per table name
    window.__tableTotals = window.__tableTotals || {};
    window.__tableTotals[props.name] = {
      hasQty: hasQtyFields,
      totalZero: hasQtyFields ? Number(totalSum) === 0 : false,
    };
  }, [hasQtyFields, totalSum, props.name]);

  useEffect(() => {
    getCatalougeData({
      schemaPageFields,
      formData,
      name,
      setCatDropDown,
      setTotalSum,
      setTotalInputSum,
      calculateSum,
      calculateInputSum,
      props,
      fetchCatalogueHeaderData,
      fetchCatalogueKeyValues,
    });
    getELCData({
      schemaPageFields,
      formData,
      name,
      setELCDropDown,
      ELLValue,
      fetchParentELCHeaderData,
      tableELLValue,
      ELLSchemaItem,
    });

    if (formData?.[name]) {
      // Only compute totals if QTY fields exist
      if (hasQtyFields) {
        setTotalSum(calculateSum(props, formData?.[name]));
        setTotalInputSum(calculateInputSum(props, formData[name]));
      }
    }
  }, [ELLValue, toggleTescoFileUploaded, formData, hasQtyFields]);
  useEffect(() => {
    if (pendingPaste) {
      const { event, rowIndex, parsedData, schemaPageFields } = pendingPaste;
      if (table.length >= rowIndex + parsedData.length) {
        handleCopyPaste(event, rowIndex, parsedData, schemaPageFields);
        setPendingPaste(null);
        setNotification("");
      }
    }
  }, [ pendingPaste]);
  async function fetchParentELCHeaderData(
    element,
    tdkeys,
    selectedValue,
    catalogueDropDown,
    rowIndex
  ) {
    setLoadingStates((prevStates) => ({
      ...prevStates,
      [tdkeys]: true, // Set loading state for this row to true
    }));

    const keyIndex = element?.schemaItem;
    const schemaId = searchParams?.get("schema_id");
    const requestKey = `${schemaId}|${selectedValue}|${keyIndex}|${tdkeys}`;

    // Check if this request is already in-flight to prevent duplicate API calls
    if (inFlightRequestKeyRef.current.has(requestKey)) {
      return; // Request already in progress, skip duplicate
    }

    // Check for duplicate: if already fetched for this selection/row, skip
    const previousSelectedValue = catalogueDropDown[keyIndex]?.key?.[tdkeys];
    const hasCachedChildOptions = Array.isArray(
      catalogueDropDown[keyIndex]?.keyValues?.[tdkeys]
    );
    const isDuplicateSelection =
      previousSelectedValue === selectedValue && hasCachedChildOptions;

    if (isDuplicateSelection) {
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [tdkeys]: false,
      }));
      return;
    }

    // Mark this request as in-flight
    inFlightRequestKeyRef.current.add(requestKey);

    if (!catalogueDropDown[keyIndex]) {
      catalogueDropDown[keyIndex] = {};
    }
    if (!catalogueDropDown[keyIndex].key) {
      catalogueDropDown[keyIndex].key = {};
    }
    if (!catalogueDropDown[keyIndex].keyValues) {
      catalogueDropDown[keyIndex].keyValues = {};
    }

    catalogueDropDown[keyIndex]["key"][tdkeys] = selectedValue;
    const getSchemaChildLinkedListItems = `${VIPSDataServiceURL}/Schema/GetSchemaChildLinkedListItems?schemaID=${schemaId}&itemID=${selectedValue}`;

    try {
      const response = await fetch(
        getSchemaChildLinkedListItems,
        requestOptions
      );
      const data = await response.json();
      catalogueDropDown[keyIndex]["keyValues"][tdkeys] = data;

      setELCDropDown(catalogueDropDown);
    } catch (error) {
      console.error("Error fetching key values:", error);
    } finally {
      setELCDropDown(catalogueDropDown);
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [tdkeys]: false, // Set loading state for this row to false
      }));
      // Mark request as complete
      inFlightRequestKeyRef.current.delete(requestKey);
    }
  }

  async function fetchCatalogueHeaderData(
    element,
    tdkeys,
    testVal,
    catalogueDropDown
  ) {
    setLoadingStates((prevStates) => ({
      ...prevStates,
      [tdkeys]: true, // Set loading state for this row to true
    }));

    const changeDropDownVal = { ...catalogueDropDown };
    const keyIndex = element?.keyIndex;
    changeDropDownVal[keyIndex]["key"][tdkeys] = testVal;
    
    let getCatalogueHeaderDataApiUrl =
      `${VIPSDataServiceURL}/Catalogue/GetCatalogueHeaderData?catId=${element?.catId}` +
      `&pageID=${element?.pageId}`;
    const entriesDropDown = Object.entries(catalogueDropDown);
    entriesDropDown.forEach(([key, value]) => {
      getCatalogueHeaderDataApiUrl += `&key${parseInt(key)}=${
        value["key"][tdkeys]
      }`;
    });
    getCatalogueHeaderDataApiUrl +=
      `&storeGrp=${store_grp}` + `&userId=${user_id}`;

    try {
      const response = await fetch(
        getCatalogueHeaderDataApiUrl,
        requestOptions
      );
      const data = await response.json();

      if (data.catData.length > 0) {
        const requiredData = data.catData;
        requiredData.forEach((field) => {
          field.forEach((x) => {
            const catalougeFields = schemaPageFields.find(
              (y) => y.catFieldId === x.ID && y.visible !== false && y.keyIndex !== 0
            )?.fieldName;
            if(catalougeFields){
            const catalougeFieldName = `${name}[${tdkeys}].${catalougeFields}`;
            setFieldValue(catalougeFieldName, x.Value);
            }
          });
        });
      } else {
        alert(getMessage("noDataFound"));
        const catName = schemaPageFields.filter((y) => y.schemaType === 24);
        if (catName.length > 0) {
          catName.forEach((x) => {
            const name2 = `${name}[${tdkeys}].${x.fieldName}`;
            setFieldValue(name2, "");
          });
        }
      }

      const catalogueDetailDataKey = entriesDropDown.reduce(
        (acc, [key, value]) => {
          acc += `&key${parseInt(key)}=${value["key"]}`;
          getCatalogueHeaderDataApiUrl += `&key${parseInt(key)}=${
            value["key"][tdkeys]
          }`;
          return acc;
        },
        ""
      );

      const catTabData = {
        value: testVal,
        element,
        catalogueDetailDataKey,
      };
      //setCatTabData(catTabData);
    } catch (error) {
      console.error("Error fetching header data:", error);
    } finally {
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [tdkeys]: false, // Set loading state for this row to false
      }));
    }
  }

  async function fetchCatalogueKeyValues(
    element,
    tdkeys,
    selectedValue,
    catalogueDropDown
  ) {
    setLoadingStates((prevStates) => ({
      ...prevStates,
      [tdkeys]: true, // Set loading state for this row to true
    }));

    const changeDropDownVal = { ...catalogueDropDown };
    const keyIndex = element?.keyIndex;
    changeDropDownVal[keyIndex]["key"][tdkeys] = selectedValue;

    const vendorId = getVendorIdFromSession();
    let getCatalogueKeyValuesApiUrl =
      `${VIPSDataServiceURL}/Catalogue/GetCatalogueKeyValues?catId=${element?.catId}` +
      `&KeyNo=${element?.keyIndex + 1}`;
    const entriesDropDown = Object.entries(catalogueDropDown);
    entriesDropDown.forEach(([key, value]) => {
      getCatalogueKeyValuesApiUrl += `&key${parseInt(key)}=${
        value["key"]?.[tdkeys] ?? ""
      }`;
    });
    getCatalogueKeyValuesApiUrl += `&vendorId=${encodeURIComponent(vendorId)}`;

    try {
      const response = await fetch(getCatalogueKeyValuesApiUrl, requestOptions);
      const data = await response.json();

      if (data.length <= 0) {
        let catTabData = {
          value: "",
          element,
          catalogueDetailDataKey: "",
        };
        setCatTabData(catTabData);
      }

      const keyValues = data?.map((x) => ({
        label: x,
        value: x,
      }));

      changeDropDownVal[keyIndex]["keyValues"][tdkeys] = keyValues;

      setCatDropDown(changeDropDownVal);
      setFieldValue(`${name}[${tdkeys}].${element.fieldName}`, selectedValue);
    } catch (error) {
      console.error("Error fetching key values:", error);
    } finally {
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [tdkeys]: false, // Set loading state for this row to false
      }));
    }
  }

  const deleteRow = async (indexToDelete) => {
    await deleteRowHelper({
      indexToDelete,
      values,
      name,
      setDeleting,
      csvUplaodEnabled,
      initialValues,
      schemaPageFields,
      setFieldValue,
      ELCDropDown,
      setELCDropDown,
      deleteItemAtIndex,
      settable,
      formData,
      setTotalSum,
      setTotalInputSum,
      calculateSum,
      calculateInputSum,
      props,
    });
  };

  // function clearValue(index, value) {
  //   if (values[name]?.[index]) {
  //     let initialValueObj = initialValues[name]?.[index];
  //     for (const [key, value] of Object.entries(initialValueObj)) {
  //       initialValueObj[key] = "";
  //     }
  //     values[name][index] = initialValueObj;
  //     let changeDropDownVal = { ...ELCDropDown };
  //     removeItemAtIndex(changeDropDownVal, index);

  //     setFieldValue(`${name}[${index}]`, initialValueObj);
  //     setTotalSum(calculateSum(props, values[name]));

  //     setTotalInputSum(calculateInputSum(props, values[name]));
  //   }
  // }

  // function removeItemAtIndex(data, index) {
  //   for (let key in data) {
  //     if (data[key].key && data[key].keyValues) {
  //       if (index >= 0 && index < data[key].key.length) {
  //         data[key].key[index] = "";
  //         data[key].keyValues[index] = [];
  //       } else {
  //       }
  //     }
  //   }

  //   setELCDropDown(data);
  // }


  function calculateTotalRows(copiedRows, pageSize) {
    return Math.ceil(copiedRows / pageSize) * pageSize;
  }

  const addMoreRowOnCopyPaste = (copiedRows) => {
    setTotalCopiedRows((prev) => {
      let addmore = [],
        initalArray = [];
      let defaultValue = Lines;
      let initialValueObj = {};
      if (initialValues[name]) {
        initialValueObj = { ...initialValues[name]?.[0] };
      }
      for (const [key, value] of Object.entries(initialValueObj)) {
        initialValueObj[key] = "";
      }
      if (table.length + defaultValue >= maxNoLines)
        defaultValue = maxNoLines - table.length;
      const newTotal = prev + copiedRows;
      const totalRowsNeeded = calculateTotalRows(newTotal, Lines);
      const rowsToBeAdded = totalRowsNeeded - table.length;

      for (let k = 0; k < rowsToBeAdded; k++) {
        addmore.push(table[0]);
        initalArray.push({ ...initialValueObj });
      }
 
      settable((current) => [...current, ...addmore]);
          if (initialValues[name]) {
        initialValues[name] = [...initialValues[name], ...initalArray];
      }
      return newTotal;
    });
  };
  const addMoreRow = () =>
    addMoreRowHelper({
      Lines,
      maxNoLines,
      table,
      initialValues,
      name,
      setFieldValue,
      values,
      settable,
    });

  const handleF8KeyPressWrapper = (event, key, rowIndex, colIndex) => {
    handleF8KeyPress(
      event,
      key,
      rowIndex,
      colIndex,
      values,
      name,
      setFieldValue,
      setTotalSum,
      setTotalInputSum,
      calculateSum,
      calculateInputSum,
      props,
      {
        schemaPageFields,
        setCatDropDown,
        setCatTabData,
        getMessage,
        catDropDown,
        store_grp,
        user_id,
        formData,
        ELLValue,
        ELCDropDown,
        searchParams,
        requestOptions,
        VIPSDataServiceURL,
        setELCDropDown,
        setLoadingStates,
      }
    );
  };

  const handleF9KeyPressWrapper = (event, rowIndex) => {
    handleF9KeyPress(event, rowIndex, {
      values,
      name,
      setFieldValue,
      getCatalougeDataOnF9KeyPress,
      schemaPageFields,
      setCatDropDown,
      setCatTabData,
      setTotalSum,
      setTotalInputSum,
      calculateSum,
      calculateInputSum,
      getMessage,
      catDropDown,
      store_grp,
      user_id,
      props,
      formData,
      getELCDataOnF9KeyPress,
      ELLValue,
      fetchParentELCHeaderData2,
      ELCDropDown,
      searchParams,
      requestOptions,
      VIPSDataServiceURL,
      setELCDropDown,
      setLoadingStates,
    });
  };
  const handleCopyPaste = (event, rowIndex, parsedData, schemaPageFields) => {
    if (!values[name]) {
      values[name] = initialValues[name] || [];
    } else {
      // Extend values array with new empty rows added by addMoreRowOnCopyPaste
      // without overwriting existing rows that already have catalogue data
      const initArr = initialValues[name] || [];
      for (let i = values[name].length; i < initArr.length; i++) {
        values[name][i] = initArr[i];
      }
    }
    if (values[name]?.[rowIndex]) {
      const el = document.getElementById(event.target.id);
      if (el) el.blur();

      const pasteErrors = [];

      parsedData.forEach((data) => {
        var i = 0;
        let rowToBeCopied2 = {};
        let value = 0;
        let roundedValue = 0;
        const currentRowIndex = rowIndex;
        schemaPageFields?.forEach((item, index) => {
          if (item.prefix === "QTY") {
            value = parseInt(data[i], 10);
            const roundToNearest = item.validation.roundOffQty;
            roundedValue = Math.max(
              item.validation.minValue,
              roundToNearest > 0
                ? Math.ceil(Math.max(1, value) / roundToNearest) *
                    roundToNearest
                : value
            ).toString();
            rowToBeCopied2["INQ" + item.tagName] = data[i];
            rowToBeCopied2[item.fieldName] = roundedValue;
            values[name][rowIndex]["INQ" + item.tagName] = data[i];
            values[name][rowIndex][item.fieldName] = roundedValue;
          }
          if (item.catalogueSchemaType !== 7) {
            if (item.schemaType !== 7) {
              const pastedVal = item.validation?.pictureMask
                ? data[i].substring(
                    0,
                    item.validation?.pictureMask?.replace(/"/g, "").length
                  )
                : item.prefix === "QTY"
                ? roundedValue
                : data[i];

              if (
                Array.isArray(item.options) &&
                item.options.length > 0 &&
                item.prefix !== "QTY"
              ) {
                const pastedLower = pastedVal.toLowerCase();
                const matchedOption = item.options.find((opt) =>
                  typeof opt === "string"
                    ? opt.toLowerCase() === pastedLower
                    : opt.value?.toLowerCase() === pastedLower
                );
                if (!matchedOption && pastedVal !== "") {
                  pasteErrors.push(
                    `Row ${currentRowIndex + 1}: "${pastedVal}" is not a valid option for field "${item.label || item.fieldName}"`
                  );
                  rowToBeCopied2[item.fieldName] = "";
                } else {
                  // Use the canonical option value so the stored value matches the dropdown's expected format
                  rowToBeCopied2[item.fieldName] = matchedOption
                    ? typeof matchedOption === "string"
                      ? matchedOption
                      : matchedOption.value
                    : pastedVal;
                }
              } else {
                rowToBeCopied2[item.fieldName] = pastedVal;
              }
              i++;
            }
          } else {
            rowToBeCopied2[item.fieldName] = "";
          }
        });
        values[name][rowIndex] = rowToBeCopied2;
        setFieldValue(`${name}[${rowIndex}]`, rowToBeCopied2);

        getELCDataOnF9KeyPress(rowIndex, false, {
          schemaPageFields,
          values,
          name,
          setELCDropDown,
          ELLValue,
          fetchParentELCHeaderData2,
          ELCDropDown,
          formData,
          setTotalSum,
          setTotalInputSum,
          calculateSum,
          calculateInputSum,
          props,
          searchParams,
          requestOptions,
          VIPSDataServiceURL,
          setLoadingStates,
        });
        getCatalougeDataOnF9KeyPress(rowIndex, true, {
          schemaPageFields,
          values,
          name,
          setCatDropDown,
          setFieldValue,
          setCatTabData,
          setTotalSum,
          setTotalInputSum,
          calculateSum,
          calculateInputSum,
          getMessage,
          catDropDown,
          store_grp,
          user_id,
          props,
          formData,
          setLoadingStates,
        });
        rowIndex++;
      });

      if (pasteErrors.length > 0) {
        setPasteError(pasteErrors);
      }

      // Recalculate totals only when QTY fields exist
      if (hasQtyFields) {
        setTotalSum(calculateSum(props, values[name]));
        setTotalInputSum(calculateInputSum(props, values[name]));
      }
    }
  };

  const handleRowKeyPress = (event, rowIndex) => {
    if (event.keyCode === 120) {
      handleF9KeyPressWrapper(event, rowIndex);
    } else if (event.keyCode === 121) {
      handleF10KeyPress(event, rowIndex, {
        values,
        name,
        setFieldValue,
        getCatalougeDataOnF9KeyPress,
        schemaPageFields,
        setCatDropDown,
        setCatTabData,
        setTotalSum,
        setTotalInputSum,
        calculateSum,
        calculateInputSum,
        getMessage,
        catDropDown,
        store_grp,
        user_id,
        props,
        formData,
        getELCDataOnF9KeyPress,
        ELLValue,
        fetchParentELCHeaderData2,
        ELCDropDown,
        searchParams,
        requestOptions,
        VIPSDataServiceURL,
        setELCDropDown,
        setLoadingStates,
        tableELLValue,
      });
    }
  };

  const handlePaste = (e, rowIndex) => {
    const pasteData = e.clipboardData.getData("text");
    if (pasteData.indexOf("\t") > 0) {
      e.preventDefault();
      const parsedData = parseExcelData(
        pasteData.replace(/\r/g, ""),
        props.schemaPageFields
      );
      setData(parsedData);

      if (parsedData.length === 0) {
        setNotification(
          `No valid data to display. Please ensure each row has ${expectedColumns} columns.`
        );
        alert(
          `The number of fields in the pasted data does not match the number of columns  in the row`
        );
      } else {
        const need = rowIndex + parsedData.length - table.length;

        if (need > 0) {
          addMoreRowOnCopyPaste(parsedData.length);
          setPendingPaste({
            event: e,
            rowIndex,
            parsedData,
            schemaPageFields: props.schemaPageFields,
          });
        } else {
          handleCopyPaste(e, rowIndex, parsedData, props.schemaPageFields);
          setNotification("");
        }
      }
    }
    return false;
  };

  const getFormElementtr = (parentkey, parentvalue) => {
    if (orientation === 1) {
      return (
        <tr key={parentvalue}>
          <td colSpan={parentkey.length}>
            <Stack direction="column">
              {parentkey.map((key, value) => (
                <div key={value}>
                  {getFormElement(
                    key,
                    value,
                    parentvalue,
                    name,
                    false,
                    false,
                    labelReference
                  )}
                </div>
              ))}
            </Stack>
          </td>
        </tr>
      );
    } else {
      return (
        <tr
          key={`row-${parentvalue}-${JSON.stringify(
            parentkey.map?.((k) => k.fieldName || k.tagName || k.prefix || "")
          )}`}
          onKeyDown={(event) => handleRowKeyPress(event, parentvalue)}
          onPaste={(event) => handlePaste(event, parentvalue)}
        >
          {Lines > 1 && (
            <td>
              <label>{parentvalue + 1}</label>
            </td>
          )}
          {imagePreviewRequired && Lines > 1 && (
            <td>
              <Tooltip
                key={`tooltip-${parentvalue}-${JSON.stringify(
                  parentkey.map?.(
                    (k) => k.fieldName || k.tagName || k.prefix || ""
                  )
                )}`}
                title="Image Preview"
              >
                <IconButton
                  onClick={() =>
                    openPopup(parentvalue, props, schemaResult, values)
                  }
                >
                  <PreviewIcon />
                </IconButton>
              </Tooltip>
            </td>
          )}

          {parentkey.map((key, value) =>
            key.prefix === "QTY" ? (
              <React.Fragment key={`qtyfrag-${parentvalue}-${value}`}>
                <Tooltip
                  key={`tooltip-${key.fieldName}-${value}`}
                  disableHoverListener
                  title="F8 - Repeat
            Field ,
            F9
            - Repeat Row,
            F10
            - Repeat to Multiple Row"
                >
                  <td
                    rowkey={parentvalue}
                    key={`qty-td-${parentvalue}-${value}`}
                    onKeyDown={(event) =>
                      handleF8KeyPressWrapper(event, key, parentvalue, value)
                    }
                  >
                    {getFormElement(
                      key,
                      value,
                      parentvalue,
                      name,
                      false,
                      false,
                      labelReference
                    )}
                  </td>
                </Tooltip>
                <td key={`InputQty-${parentvalue}-${value}`}>
                  {getFormElement(
                    key,
                    value,
                    parentvalue,
                    name,
                    showInputQuantity,
                    false,
                    labelReference
                  )}
                </td>
              </React.Fragment>
            ) : (
              key.visible !== false &&
              key.display !== false &&
              (csvUplaodEnabled
                ? key.prefix !== "STC"
                  ? true
                  : columnsWithAnyData && columnsWithAnyData.includes(key.fieldName)
                : true) && (
                  <Tooltip
                  key={`tooltip-other-${parentvalue}-${value}`}
                  disableHoverListener
                  title="F8 - Repeat
                Field ,
                F9
                - Repeat Row,
                  F10
                  - Repeat to Multiple Row"
                >
                  <td
                    rowkey={parentvalue}
                    key={`cell-${parentvalue}-${value}`}
                    onKeyDown={(event) =>
                      handleF8KeyPressWrapper(event, key, parentvalue, value)
                    }
                  >
                    {getFormElement(
                      key,
                      value,
                      parentvalue,
                      name,
                      false,
                      false,
                      labelReference
                    )}
                  </td>
                </Tooltip>
              )
            )
          )}

          {parentkey.map(
            (key, value) =>
              key.prefix === "QTY" && (
                <td key={`WastageQty-${parentvalue}-${value}`}>
                  {getFormElement(
                    key,
                    value,
                    parentvalue,
                    name,
                    false,
                    showWastageOption,
                    labelReference
                  )}
                </td>
              )
          )}
          {prefix !== "CTB" && maxNoLines > 1 && (
            <td key={`buttons-${parentvalue}`}>
              {!csvUplaodEnabled && (
                <Button
                  variant="contained"
                  rowkeys={parentkey}
                  tdkeys={parentkey}
                  onClick={() => deleteRow(parentvalue, parentkey)}
                  className="clearbtn"
                >
                  Clear Row
                </Button>
              )}
              {csvUplaodEnabled && (
                <Button
                  variant="contained"
                  rowkeys={parentkey}
                  tdkeys={parentkey}
                  disabled={deleting}
                  onClick={() => deleteRow(parentvalue, parentkey)}
                  className="clearbtn"
                >
                  {deleting ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Delete Row"
                  )}
                </Button>
              )}
            </td>
          )}
        </tr>
      );
    }
  };
  const [tableChildOpts, setTableChildOpts] = useState({});
  // key is `${rowIndex}_${childItemId}` for per-row isolation
  const updateTableChildOpt = ({ childItemId, tdkeys: rowIndex, optionsData }) => {
    if (childItemId != null && rowIndex != null) {
      const key = `${rowIndex}_${childItemId}`;
      setTableChildOpts((prev) => ({ ...prev, [key]: optionsData }));
    }
  };

  // Seed per-row tableChildOpts from saved formData (amend / return-to-ordering).
  useEffect(() => {
    const rows = Array.isArray(formData?.[name]) ? formData[name] : [];
    if (!schemaPageFields || rows.length === 0) return;

    const lliFields = schemaPageFields.filter(
      (f) => f.prefix === "LLI" && f.childItemId && f.childLists
    );
    if (lliFields.length === 0) return;

    const newOpts = {};
    for (const lliField of lliFields) {
      const childEl = schemaPageFields.find((f) => f.schemaItem === lliField.childItemId);
      const defaultOptions = childEl?.options || [];

      rows.forEach((row, rowIndex) => {
        let optionsData = defaultOptions;
        const savedLabel = row?.[lliField.fieldName];
        if (savedLabel) {
          const optionValue = (lliField.options || []).find((x) => x.label === savedLabel)?.value;
          if (optionValue != null) {
            const entry = Object.entries(lliField.childLists).find(
              ([key]) => String(key) === String(optionValue)
            );
            if (entry) optionsData = entry[1];
          }
        }
        newOpts[`${rowIndex}_${lliField.childItemId}`] = optionsData;
      });
    }

    setTableChildOpts((prev) => ({ ...prev, ...newOpts }));
  }, [formData, name, schemaPageFields]);

  const [tableELLValue, setTableELLValue] = useState({});

  const handleTableELLValueChange = (rowIndex, value) => {
    setTableELLValue((prev) => {
      const newValue = {
        ...prev,
        [rowIndex]: value,
      };
      return newValue;
    });
  };
  const getFormElement = (
    element,
    key,
    parentvalue,
    tableName,
    showInputQuantity,
    showWastageOption,
    labelReference,
    catalogueChildOptn
  ) => {
    const { pageId, schemaItem } = element;
    const id = element.prefix + pageId + element.tagName + labelReference;
    const name = element.fieldName;
    let option = element.options;
    let keyValues = element.keyValues;
    const rowkeys = key;

    const tdkeys = parentvalue;
    const error = errors?.[tableName]?.find((x) => x?.index === tdkeys);
    const errorBorder = error?.[name] ? "error-border" : "";

    return (
      <DynamicFieldRenderer
        element={element}
        tableName={tableName}
        tdkeys={tdkeys}
        name={name}
        values={values}
        setFieldValue={setFieldValue}
        error={error}
        errorBorder={errorBorder}
        id={id}
        rowkeys={rowkeys}
        showInputQuantity={showInputQuantity}
        showWastageOption={showWastageOption}
        setTotalSum={setTotalSum}
        setTotalInputSum={setTotalInputSum}
        props={props}
        childOpt={childOpt}
        setChildOpt={setChildOpt}
        tableChildOpts={tableChildOpts}
        updateTableChildOpt={updateTableChildOpt}
        pageId={pageId}
        schemaItem={schemaItem}
        option={option}
        csvUplaodEnabled={csvUplaodEnabled}
        catDropDown={catDropDown}
        setCatDropDown={setCatDropDown}
        ELCDropDown={ELCDropDown}
        setELCDropDown={setELCDropDown}
        loadingStates={loadingStates}
        setCatTabData={setCatTabData}
        schemaPageFields={schemaPageFields}
        itemId={itemId}
        parentvalue={parentvalue}
        resetELCList={resetELCList}
        ELLValue={ELLValue}
        handleResetELCList={handleResetELCList}
        fetchParentELCHeaderData={fetchParentELCHeaderData}
        schemaPageId={schemaPageId}
        schemaResult={schemaResult}
        searchParams={searchParams}
        setOptionsForChild={handleSetOptionsForChild}
        parentELCValue={parentELCValue}
        childOptions={childOptions}
        setParentELCValue={setParentELCValue}
        SetcatalogueChildOptn={SetcatalogueChildOptn}
        catalogueChildOptn={catalogueChildOptn}
        user_id={user_id}
        store_grp={store_grp}
        handleELLValue={handleELLValue}
        tableELLValue={tableELLValue}
        handleTableELLValueChange={handleTableELLValueChange}
        formData={formData}
        handleELLVSchemaItem={handleELLVSchemaItem}
        ELLSchemaItem={ELLSchemaItem}
      />
    );
  };

  const renderSchemaCells = (schema, schIndex) => {
    if (schema.schemaType === 16) {
      return (
        <React.Fragment key={schIndex}>
          <td>
            <Field type="text" value={totalSum} disabled />
          </td>
          <td>
            <label>{totalInputSum}</label>
          </td>
          <td></td>
          <td></td>
        </React.Fragment>
      );
    } else {
      const isVisible = csvUplaodEnabled
        ? schema.prefix !== "STC"
          ? true
          : columnsWithAnyData && columnsWithAnyData.includes(schema.fieldName)
        : schema.visible !== false && schema.visible !== false;

      return isVisible ? <td key={schIndex}></td> : null;
    }
  };

  return (
    <>
      <Snackbar
        open={Boolean(pasteError)}
        autoHideDuration={10000}
        onClose={() => setPasteError(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setPasteError(null)}
          severity="warning"
          variant="filled"
          sx={{ width: "100%", maxWidth: 560 }}
        >
          <strong>Some pasted values did not match available options and were left blank:</strong>
          <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
            {pasteError?.map((err, i) => (
              <li key={i} style={{ fontSize: 13 }}>{err}</li>
            ))}
          </ul>
        </Alert>
      </Snackbar>
      <TableBody>
        {table.length > 0 &&
          table.map((parentkey, parentvalue) =>
            getFormElementtr(parentkey, parentvalue)
          )}
        <tr>
          {Lines > 1 && <td></td>}
          {imagePreviewRequired && Lines > 1 && <td></td>}
          {props.schemaPageFields &&
            props.schemaPageFields.map(renderSchemaCells)}
        </tr>
      </TableBody>
      {table.length < maxNoLines && Lines > 1 && (
        <tfoot>
          <tr>
            <td
              colSpan={
                maxNoLines > 1
                  ? imagePreviewRequired
                    ? table.length + 5
                    : table.length + 4
                  : table.length + 1
              }
            >
              <Button
                type="button"
                variant="contained"
                className="clearbtn align-left-button"
                onClick={addMoreRow}
                  sx={{ textTransform: "none" }}
         size="small"
              >
                More
              </Button>
            </td>
          </tr>
        </tfoot>
      )}
    </>
  );
}

export default TableBodyFormik;
